// Usage examples:
{
  /* <countdown-component datetime="{{ date }}" data-end-text="Coming soon" role="timer">
    {{ date }}
  </countdown-component> */
}
class Countdown extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
  }

  connectedCallback() {
    this.startCountdown();
  }

  disconnectedCallback() {
    this.stopCountdown();
  }

  startCountdown() {
    const datetime = this.getAttribute('datetime');
    if (!datetime) return;

    const endDate = new Date(datetime);
    if (isNaN(endDate)) return;

    this.updateCountdown(endDate);
    this.interval = setInterval(() => this.updateCountdown(endDate), 1000);
  }

  stopCountdown() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  updateCountdown(endDate) {
    const now = new Date();
    const timeRemaining = endDate - now;

    if (timeRemaining <= 0) {
      const endText = this.querySelector('[data-end-text]')?.innerHTML;
      if (endText) this.innerHTML = endText;
      this.stopCountdown();
      return;
    }

    const days = String(Math.floor(timeRemaining / (1000 * 60 * 60 * 24))).padStart(2, '0');
    const hours = String(Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0');
    const minutes = String(Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
    const seconds = String(Math.floor((timeRemaining % (1000 * 60)) / 1000)).padStart(2, '0');

    const daySingularText = this.getAttribute('data-day-singular') || 'day';
    const daysPluralText = this.getAttribute('data-day-plural') || 'days';
    const hourSingularText = this.getAttribute('data-hour-singular') || 'hour';
    const hoursPluralText = this.getAttribute('data-hour-plural') || 'hours';
    const minuteSingularText = this.getAttribute('data-minute-singular') || 'minute';
    const minutesPluralText = this.getAttribute('data-minute-plural') || 'minutes';
    const secondsPluralText = this.getAttribute('data-second-plural') || 'seconds';

    const daysText = days === '01' ? daySingularText : daysPluralText;
    const hoursText = hours === '01' ? hourSingularText : hoursPluralText;
    const minutesText = minutes === '01' ? minuteSingularText : minutesPluralText;
    // Don't change seconds to avoid layout shift
    const secondsText = secondsPluralText;

    this.innerHTML = `
      <span>${days}&nbsp;${daysText}</span>
      <span>${hours}&nbsp;${hoursText}</span>
      <span>${minutes}&nbsp;${minutesText}</span>
      <span>${seconds}&nbsp;${secondsText}</span>
    `;
  }
}

customElements.define('countdown-component', Countdown);
